import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import * as valid from 'utils/validate';
import { KBInput,
KBButton,
KBPopoverTop } from
'components';

var LocationProviderForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.createLocationProvider = this.createLocationProvider.bind(this);}getInitialState()
  {
    return {};
  }createLocationProvider(

  model) {
    const { callBack, index } = this.props;
    callBack && callBack(model, index);
    KBPopoverTop.close();
  }render()

  {
    const {
      fields: {
        info,
        contact_name,
        contact_phone,
        account_bank,
        account_name,
        account_number,
        contact_email,
        physical_address,
        business_license_number,
        swift_code },

      error,
      submitting,
      handleSubmit } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.createLocationProvider)}>
        <header className="kb-form-header">
          <h2 className="header-title">添加收款账户信息(银行)</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopoverTop.close} />

        </header>
        <div className="kb-form-container">
          <fieldset className="fieldset">
            <div className="kb-row">
              <Field name="info" component={renderKBInput}
              className="kb-form-group kb-div-c178 kb-form-alone"

              title="账户信息"
              isRequired={true} />

            </div>
            <div className="kb-row">
              <Field name="physical_address" component={renderKBInput}
              className="kb-form-group kb-div-c178 kb-form-alone"

              title="账户地址"
              isRequired={true} />

            </div>
            <div className="kb-row">
              <Field name="account_bank" component={renderKBInput}
              className="kb-form-group kb-div-c178 kb-form-alone"

              title="账户开户银行"
              isRequired={true} />

            </div>
            <div className="kb-row kb-form-66">
              <Field name="account_name" component={renderKBInput}
              className="kb-form-group kb-div-48"

              title="账户名"
              isRequired={true} />

              <Field name="account_number" component={renderKBInput}
              className="kb-form-group kb-div-48"

              title="账号"
              titleClass="label-rt"
              isRequiredR={true} />

            </div>
            <div className="kb-form-66">
              <Field name="contact_name" component={renderKBInput}
              className="kb-form-group kb-div-48"

              title="联系人"
              isRequired={true} />

              <Field name="contact_phone" component={renderKBInput}
              className="kb-form-group kb-div-48"

              title="联系方式"
              titleClass="label-rt"
              isRequiredR={true} />

            </div>
            <div className="kb-form-66">
              <Field name="business_license_number" component={renderKBInput}
              className="kb-form-group kb-div-48"

              title="统一社会信用代码"
              isRequired={true} />

              <Field name="swift_code" component={renderKBInput}
              className="kb-form-group kb-div-48"

              title="SWIFT代码"
              titleClass="label-rt"
              isRequiredR={true} />

            </div>
          </fieldset>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopoverTop.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}
            id="locationFormButton">

              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const { provider } = props;

  return {
    initialValues: {
      info: provider && provider.info.value,
      contact_name: provider && provider.contact_name.value,
      contact_phone: provider && provider.contact_phone.value,
      account_bank: provider && provider.account_bank.value,
      account_name: provider && provider.account_name.value,
      account_number: provider && provider.account_number.value,
      physical_address: provider && provider.physical_address.value,
      business_license_number:
      provider && provider.business_license_number.value,
      swift_code: provider && provider.swift_code.value } };


}

function mapDispatchToProps(dispatch) {
  return {};
}

const validate = values => {
  const errors = {};

  if (valid.required(values.info)) {
    errors.info = '请填写收款账户信息';
  }
  if (valid.required(values.contact_name)) {
    errors.contact_name = '请填写账户联系人';
  }
  if (valid.required(values.physical_address)) {
    errors.physical_address = '请填写账户联系地址';
  }
  if (valid.required(values.contact_phone)) {
    errors.contact_phone = '请填写账户联系电话';
  }
  if (valid.required(values.account_bank)) {
    errors.account_bank = '请填写账户开户银行';
  }
  if (valid.required(values.account_name)) {
    errors.account_name = '请填写账户名';
  }
  if (valid.required(values.account_number)) {
    errors.account_number = '请填写账号';
  }
  if (valid.required(values.business_license_number)) {
    errors.business_license_number = '请填写统一社会信用代码';
  }
  if (valid.required(values.swift_code)) {
    errors.swift_code = '请填写SWIFT代码';
  }
  return errors;
};

const LEGACY_FORM_FIELDS = [
  "info",
  "contact_name",
  "contact_phone",
  "account_bank",
  "account_name",
  "account_number",
  "contact_email",
  "physical_address",
  "business_license_number",
  "swift_code"
];

const formConfig = {
  form: 'LocationProviderForm',
  validate: validate,
  touchOnBlur: false };


LocationProviderForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('LocationProviderForm', LEGACY_FORM_FIELDS)(LocationProviderForm)));

export default LocationProviderForm;
